import { Cohort } from '~/shared/constants/commonConstants'
import { TIdToPageMap } from '~/shared/types/commonTypes'

import {
  ANATOMY_PAGE_MAP_V1,
  ANATOMY_V2_PAGE_MAP_V1,
  ART_PAGE_MAP_V1,
  COMMUNICATION_PAGE_MAP_V1,
  GENERAL_PAGE_MAP_V1,
  HISTORY_PAGE_MAP_V1,
  ID_TO_PAGE_MAP_V1,
} from './PageIdMap'

export const getPageMapByCohort = (cohort: string): TIdToPageMap => {
  switch (cohort) {
    case Cohort.ANATOMY:
    case Cohort.ANATOMY_EXT:
    case Cohort.ANATOMY_ALT:
      return ANATOMY_PAGE_MAP_V1
    case Cohort.ANATOMY_V2:
      return ANATOMY_V2_PAGE_MAP_V1
    case Cohort.HISTORY:
      return HISTORY_PAGE_MAP_V1
    case Cohort.COMMUNICATION:
      return COMMUNICATION_PAGE_MAP_V1
    case Cohort.ART:
      return ART_PAGE_MAP_V1
    case Cohort.GENERAL:
      return GENERAL_PAGE_MAP_V1
    case Cohort.BIOLOGY:
    default:
      return ID_TO_PAGE_MAP_V1
  }
}
